/**
 * Hook for retrieving a value by key from localStorage, as well as for modifying this value
 * @param {String} key - item key
 * @param initValue - default value for initializing the value for a key
 * @returns a tuple of the current value and a setter function to modify this value
 *
 * @example const [filters, setFilters] = useLocalStorage("filters", []);
 */

const useLocalStorage = <T = any>(key: string, initValue: any = '') => {
  if (localStorage.getItem(key) === null) {
    localStorage.setItem(key, JSON.stringify(initValue));
  }

  const currentValue = JSON.parse(localStorage.getItem(key) ?? '') as T;
  const setValue = (value: any) => localStorage.setItem(key, JSON.stringify(value));
  return [currentValue, setValue] as const;
};

export default useLocalStorage;
